const he = require("he");
export const Latestblocks = {
  headstyle: he.encode(``),
  bodystyle: he.encode(
    `<tr>
<td>
    <span class='mono-name brdr-radius'>
        BK
    </span>
</td>
<td>
<h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</h6>
    <p>\${timestamp}</p>
</td>
<td>
    <h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')"><span>Hash </span>\${blockhash.slice(0,18)+'...'+blockhash.slice(-6)}</h6>
    <p>
        <span>\${transactioncount} tx</span> in \${timestamp}
    </p>
</td>
<td>
    <p class='price-p'>
        0 AMG
    </p>
</td>
</tr>
`
  ),
};
export const LatestTransactions = {
  headstyle: he.encode(``),
  bodystyle: he.encode(
    `    <tr>
    <td><span class="mono-name">TB</span></td>
    <td>
      <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">$\{hash.slice(0,10)+'...'+hash.slice(-3)}</h6>
      <p>\${DaysSince(timestamp)}</p>
    </td>
    <td>

      <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')"><span>From</span>  \${fromaddress.slice(0,18)+'...'+fromaddress.slice(-6)}</h6>
      <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"><span>To</span> \${toaddress.slice(0,18)+'...'+toaddress.slice(-6)}</h6>
    </td>
    <td>
      <p class="price-p">\${Valuewithoutsymbol} AMG</p>
    </td>
  </tr>
`
  ),
};

export const AllTransactions = {
  headstyle: he.encode(
    `<tr>
    <th>Txn Hash</th>
    <th>Block</th>
    <th>Age</th>
    <th>From</th>
    <th>To</th>


    <th onclick=window.sortDec()>Value
    <span>\${OrderAmount()}<span>
    </th>

    <th>Txn Fee</th>
    <th>Status</th>

  </tr>`
  ),
  bodystyle: he.encode(
    `
 <tr>
<td>
  <div class='d-flex'>
      <button style="cursor:pointer;" class='eyee-btn'><i   class='fa fa-eye'onclick="window.Navigateto('/tx/\${hash}')"  ></i></button> <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash?.slice(0, 16) +
        "...." +
        hash?.slice(-6)}</h6>
  </div>
</td>

<td>

  <h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</h6>
</td>
<td>
  <p>\${timestamp}</p>
</td>
<td>
  <h6  style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,15)+"..."+fromaddress?.slice(-3)}</h6>
</td>
<td>
  <h6  style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')">\${toaddress?.slice(0,15)+"..."+toaddress?.slice(-3)}</h6>
</td>
<td>
  <p>
   \${valuewithoutsymbol} AMG 
    </p>
</td>
<td>
  <p>
      0 AMG
  </p>
</td>
<td>
<p>\${!status ?
  \`<img class="txSuccessLogo" title="Success" src="txSuccessLogo"/>\`
  :
    \`<img class="txRevertedLogo" title="Reverted" src="txRevertedLogo"/>\`
}
</p>
</td>
</tr>
 `
  ),
};
export const AllBlock = {
  headstyle: he.encode(
    `<tr>

    
                                                        <th>Block</th>
                                                        <th>Age</th>
                                                        <th>Transaction</th>
                                                        <th>Hash</th>
                                                        <th>Gas Used</th>
                                                        <th>Gas Limit</th>
                                                        <th>Block Reward</th>
                                                    
  </tr>`
  ),
  bodystyle: he.encode(
    `
    <tr>
    <td>
        <h6  style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</h6>
    </td>
    <td>
        <p>\${timestamp}</p>
    </td>
    <td>
        <p>\${transactioncount}</p>
    </td>
    <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blockhash?.slice(0,15)+"..."+blockhash?.slice(-3)}</h6>
    </td>
    <td>
        <p>
\${gasused}
        </p>
    </td>
    <td>
        <p>
        \${gaslimit}
        </p>
    </td>
    <td>
        <p>
        \${blockreward} AMG
        </p>
    </td>
</tr>
 `
  ),
};

export const TopToken = {
  headstyle: he.encode(
    `<tr>
    <th>Holders</th>
    <th>Token</th>
    <th>Address</th>
    <th>Decimal</th>
    <th>Balance</th>
    <th>Symbol</th>
</tr>`
  ),
  bodystyle: he.encode(
    `
    <tr>
    <td>
        <p>\${holdercount}</p>
    </td>
    <td>
        <p> \${name}</p>
    </td>
    <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">\${tokenaddress?.slice(0, 12) + '...' + tokenaddress?.slice(-4)}</h6>
    </td>
    <td>
    <p> \${decimal}</p>
</td>
    <td>
        <p> \${totalsypply}</p>
        
    </td>
    <td>
        <p>

\${sybmol}
        </p>
    </td>
</tr>
 `
  ),
};
export const tokentransfer = {
  headstyle: he.encode(
    ` <tr>
    <th>Txn Hash</th>
    <th>Age</th>
    <th>From</th>
    <th>To</th>
    <th>Block </th>
    <th>Token</th>
</tr>`
  ),
  bodystyle: he.encode(
    `<tr>
                                                         <td className="d-flex"> 
                                                            <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${Txhash}')">\${Txhash?.slice(0,18)+"..." }</h6>
                                                        </td>
                                                        <td>
                                                            <p>\${timestamp}</p>
                                                        </td>

                                                        <td>
                                                        <p className="bg" style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,15)+"..."}</p>
                                                      </td>
                                                      <td>
                                                        <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,15)+"..."}</h6>
                                                      </td>
                                                      <td>
                                                      <p>\${blocknumber}</p></td>
                                                        <td>
                                                            <h6 style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">\${tokenaddress?.slice(0,15)+"..."}</h6>
                                                        </td>
                                                      
                                                    </tr>
                                                    <tr>

</tr>
 `
  ),
};
export const internaltx = {
  headstyle: he.encode(
    `<tr>
    <th>Hash</th>
    <th>From</th>
    <th>To</th>
    <th>Block</th>
    <th>Age</th>
    
</tr>`
  ),
  bodystyle: he.encode(
    `
    <tr>
      <td>
        <div className="d-flex">
          <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">
            \${hash?.slice(0,21)+"..."}
          </h6>
        </div>
      </td>
      <td>
        <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,21)+"..."}</p>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')">\${toaddress?.slice(0,21)+"..."}</h6>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</h6>
      </td>
      <td>
        <h6>\${timestamp}</h6>
      </td>
    </tr>
  
 `
  ),
};
export const AddressTokentransfer = {
  headstyle: he.encode(`<tr>
  <th>Hash</th>
  <th>Block</th>
  <th>Age</th>
  <th>From</th>
  <th>To</th>
  <th>Value</th>
</tr>`),
  bodystyle: he.encode(
    `<tr>
    <td>
  <div class='d-flex'>
       <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')"> \${hash?.slice(0, 19) +
        "...." +
        hash?.slice(-3)}</h6>
  </div>
</td>

<td>

  <p   style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</p>
</td>
<td>
  <p>\${DaysSince(timestamp)}</p>
</td>

<td>
  <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,15)+"..."+fromaddress?.slice(-3)}</h6>
</td>
<td>
  <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')">\${(toaddress?.slice(0,15)+"..."+toaddress?.slice(-3))}</h6>
</td>
<td>
  <p>
   \${valuewithoutsymbol } AMG 
    </p>
</td>

  </tr>`
  ),
};
export const Tokentranstion = {
  headstyle: he.encode(` <tr>
  <th>Address</th>
 
  <th>Name</th>
  <th>Symbol</th>
  <th>value</th>
  <th>Type</th>
  <th>Block </th>
  
</tr>`),
  bodystyle: he.encode(
    `<tr>
    <td>
    <div >
    <p style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">\${tokenaddress?.slice(0,21)+"..."}</p>
    </div>
  </td>
    <td>
    <p className="bg">\${tokenname}</p>
    
  </td>
    <td>
    <p className="bg">\${tokensymbol}</p>
    
  </td>
    <td>
    <p className="bg">\${valuewithoutsymbol } AMG</p>
    
  </td>
    <td>
    <p className="bg">\${tokentype}</p>
    
  </td>
    <td>
    <p  style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</p>
    
  </td>


  </tr>`
  ),
};
export const AddressTokentranstion = {
  headstyle: he.encode(
    ` <tr>
  <th>Token</th>
 
  <th>From</th>
  <th>To</th>
  <th>	Transaction</th>
  
</tr>`
  ),
  bodystyle: he.encode(
    `<tr>
    <td>
        <div className="d-flex">
          <h6  style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">
            \${tokenaddress?.slice(0,10)+"..."+tokenaddress?.slice(-4)}
          </h6>
        </div>
      </td>
      <td>
        <p  style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,10)+"..."+fromaddress?.slice(-4)}</p>
      </td>
      <td>
        <h6  style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,10)+"..."+toaddress?.slice(-4)}</h6>
      </td>
      
      <td>
        <h6  style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash.slice(0, 5) + '....' + hash.slice(-4)}
        </h6>
      </td>
    
  </tr>`
  ),
};
export const blockTransaction = {
  headstyle: he.encode(
    `<tr>
    <th>Hash</th>
   
    <th>From</th>
    <th>To</th>
    <th>Amount</th>
    <th>Age</th>
    <th>Status</th>
    
    
</tr>`
  ),
  bodystyle: he.encode(
    `
    <tr>
      <td>
        <div className="d-flex">
          <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">
            \${hash?.slice(0,15)+"..."+hash?.slice(-4)}
          </h6>
        </div>
      </td>
      <td>
        <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,21)+"..."}</p>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,21)+"..."}</h6>
      </td>
      <td>
        <h6>\${valuewithoutsymbol } AMG</h6>
      </td>
      
      <td>
        <h6>\${timestamp}</h6>
      </td>
      <td>
        <h6>\<img class="txSuccessLogo" title="Success" src="txSuccessLogo"/>
        </h6>
      </td>
    </tr>
  
 `
  ),
};

// export const logs = {
//   headstyle: he.encode(
//     ``
//   ),
//   bodystyle: he.encode(
//     `
//  `
//   ),
// };

export const TokenTransactionS = {
  headstyle: he.encode(
    `<tr>
    <th>Txn Hash</th>
    <th>Block</th>
    <th>Age</th>
    <th>From</th>
    <th>To</th>
    <th>Value</th>
  </tr>`
  ),
  bodystyle: he.encode(
    `
 <tr>
<td>
  <div class='d-flex'>
       <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash?.slice(0, 19) +
        "...." +
        hash?.slice(-3)}</h6>
  </div>
</td>

<td>

  <p  style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</p>
</td>
<td>
  <p>\${DaysSince(timestamp)}</p>
</td>

<td>
  <h6  style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,15)+"..."+fromaddress?.slice(-3)}</h6>
</td>
<td>
  <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')">\${toaddress?.slice(0,15)+"..."+toaddress?.slice(-3)}</h6>
</td>
<td>
  <p>
   \${valuewithoutsymbol } AMG 
    </p>
</td>

</tr>
 `
  ),
};

export const tokeninternaltx = {
  headstyle: he.encode(
    `<tr>
    <th>Hash</th>
    <th>From</th>
    <th>To</th>
    <th>Block </th>
    <th>Time_Sptamp</th>
    
</tr>`
  ),
  bodystyle: he.encode(
    `
    <tr>
      <td>
        <div className="d-flex">
          <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">
          \${hash?.slice(0, 19) +
            "...." +
            hash?.slice(-3)}
          </h6>
        </div>
      </td>
      <td>
        <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,21)+"..."}</p>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,21)+"..."}</h6>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/block/\${blocknumber}')">\${blocknumber}</h6>
      </td>
      <td>
      <p>\${DaysSince(timestamp)}</p>
      </td>
    </tr>
  
 `
  ),
};

export const tokentransaction2 = {
  headstyle: he.encode(
    ` <tr>
  <th>Token</th>
 
  <th>From</th>
  <th>To</th>
  <th>	Transaction</th>
  
</tr>`
  ),
  bodystyle: he.encode(
    `<tr>
    <td>
        <div className="d-flex">
          <h6 style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">
            \${tokenaddress?.slice(0,10)+"..."+tokenaddress?.slice(-4)}
          </h6>
        </div>
      </td>
      <td>
        <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,10)+"..."+fromaddress?.slice(-4)}</p>
      </td>
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,10)+"..."+toaddress?.slice(-4)}</h6>
      </td>
      
      <td>
        <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash.slice(0, 5) + '....' + hash.slice(-4)}
        </h6>
      </td>
    
  </tr>`
  ),
};

export const Tokentranst = {
  headstyle: he.encode(` 
  '<tr>
  <th>Token</th>
 
  <th>From</th>
  <th>To</th>
  <th>	Transaction</th>
  </tr> `),
  bodystyle: he.encode(
    `<tr>
    <td>
    <div className="d-flex">
      <h6 style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">
        \${tokenaddress?.slice(0,10)+"..."+tokenaddress?.slice(-4)}
      </h6>
    </div>
  </td>
  <td>
    <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,10)+"..."+fromaddress?.slice(-4)}</p>
  </td>
  <td>
    <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,10)+"..."+toaddress?.slice(-4)}</h6>
  </td>
  
  <td>
    <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash.slice(0, 5) + '....' + hash.slice(-4)}
    </h6>
  </td>

  </tr>`
  ),
};
export const TaransationTokentranst = {
  headstyle: he.encode(`<tr>
  <th>Token</th>
 
  <th>From</th>
  <th>To</th>
  <th>	Transaction</th>
  </tr> `),
  bodystyle: he.encode(
    `<tr>
    <td>
    <div className="d-flex">
      <h6 style="cursor:pointer" onclick="window.Navigateto('/token/\${tokenaddress}')">
        \${tokenaddress?.slice(0,10)+"..."+tokenaddress?.slice(-4)}
      </h6>
    </div>
  </td>
  <td>
    <p style="cursor:pointer" onclick="window.Navigateto('/address/\${fromaddress}')">\${fromaddress?.slice(0,10)+"..."+fromaddress?.slice(-4)}</p>
  </td>
  <td>
    <h6 style="cursor:pointer" onclick="window.Navigateto('/address/\${toaddress}')"> \${toaddress?.slice(0,10)+"..."+toaddress?.slice(-4)}</h6>
  </td>
  
  <td>
    <h6 style="cursor:pointer" onclick="window.Navigateto('/tx/\${hash}')">\${hash.slice(0, 5) + '....' + hash.slice(-4)}
    </h6>
  </td>

  </tr>`
  ),
};
